// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '../static/css/commonality.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/common/style.css'
import $ from "jquery"
window.$=window.jQuery=$;
import ElementUI from 'element-ui'
import Axios from 'axios'
import Vue from 'vue'
import App from './App'
import router from './router'
import "babel-polyfill";
import wem from 'wem';

//import '../static/js/jquery-2.0.0.min.js'
//2024-6-25 应运维要求升级jq版本为3.0.0
//import  '../static/js/jquery-3.0.0.min.js'


import echarts from '../static/js/echarts.js'
import echart from 'echarts'
import '../static/js/md5.js'

import '../static/js/OstPaths.js'
import '../static/js/DataDict.js'
import '../static/js/SubAreas.js'
import '../static/js/DataStore.min.js'
import '../static/js/AreaLinkage.js'
import '../static/js/ajaxFileDownloader.js'
import {getCookie} from '../static/js/cookie.js'
import {formatFn} from '../static/js/date.js'
import {setCookie} from '../static/js/cookie.js'
import {delCookie} from '../static/js/cookie.js'
import {numberFormat} from '../static/js/common.js'
import {getV} from '../static/js/common.js'
import '../static/js/CFInstall.js'
import '../static/js/gcfutil.js'

Vue.use(ElementUI);

Vue.prototype.Axios = Axios;
Vue.prototype.getCookie = getCookie;
Vue.prototype.setCookie = setCookie;
window.setCookie = setCookie;
window.numberFormat = numberFormat;
window.getV = getV;
Vue.prototype.delCookie = delCookie;
Vue.prototype.formatFn = formatFn;
Vue.prototype.$w = wem;
Vue.prototype.$echars = echarts;
Vue.prototype.$echarts = echart;
Vue.prototype.Axios.defaults.withCredentials = true;
Vue.prototype.Axios.defaults.headers = {
  'Content-Type': 'application/json'
};
Vue.prototype.Axios.defaults.xhrFields = {
  withCredentials: true
};


Vue.prototype.openLoading = function() {
  const loading = this.$loading({
    lock: true,
    text: '正在加载...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.3)',
    target: '.sub-main',
    body: true,
    customClass: 'mask'
  })
  return loading;
}


Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
  data() {
    return {
      errUrl: '',
      news: false,
      is901: false
    }
  },
  methods: { 
        urljudge:function(){//添加一个响应拦截器
          //setCookie("userInfo",JSON.stringify({"tokenType":'bearer',"accessToken":"eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJkZXB0X2NvdW50cnkiLCJ1c2VyX25hbWUiOiJkZXB0X2NvdW50cnkiLCJvcGVuSWQiOiIzYjY4ZDFhMjY4OTQxMWU4OGQ0NjA4MDAyN2U3ZjY1YyIsInVzZXJJZCI6MTAsImF1dGhvcml0aWVzIjpbIlJPTEVfZGVwdF9jb3VudHJ5IiwiUk9MRV91c2VyIiwiYWN0aXZlZCJdLCJleHAiOjE1ODU3OTE4OTV9.QHq5uxIS1KVFMIAkiypOq4Qn7lFDCaA0QosEgK4G892H4T1rnmkirJP0kkrTbBKvCl6KZc5Fdr2nxV2dKMDA-UOAMx65No7yqtWBNIOXiRerj46951SOG9F9n4HM27g2fi5nSohen_Dcx-LQio4l2nPvh8hQgwYHvCBQzoSMHjc"}));
          //setCookie("userInfo",JSON.stringify({"tokenType":'bearer',"accessToken":"eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJ6anNoYW5nemhvdXNoaTAxIiwidXNlcl9uYW1lIjoiempzaGFuZ3pob3VzaGkwMSIsIm9wZW5JZCI6IjNiNjk4Mzk5Njg5NDExZTg4ZDQ2MDgwMDI3ZTdmNjVjIiwidXNlcklkIjo5MDksImF1dGhvcml0aWVzIjpbIlJPTEVfdXNlciIsImFjdGl2ZWQiLCJST0xFX2RlcHRfY2l0eSJdLCJleHAiOjE1NjczMTE4MDV9.RosnNLOAf5XymXAMfrPO6AiWBLBvNmIdi64IrzjOlPQMIFGLljV5GjRh0SLmw_seTwChOdnqbgrAnBENOc9B71OzyAyRQwnaXP-YW4z2WpLbXJZCYT1V91z2Qcsd1XWjn3-TSM1GKP_9_fpmsGK1OILTAGEjj1EmH8CUwNaMFKg"})); 
          let urlList = "login,loginlist,testPage,loginDrugFirm";
          var locationUrl = window.location.pathname;
          if(getCookie('userInfo')) {//添加公用 Authorization
            this.setToken()
          } else {
            let str = locationUrl.substring(1,locationUrl.length)
            if(urlList.indexOf(str)==-1||str==''){
              this.$router.push("/loginlist")
            }
          }
    },
    setToken(){//设置token
      let token=JSON.parse(getCookie('userInfo')).tokenType+ ' ' + JSON.parse(getCookie('userInfo')).accessToken
      Axios.defaults.headers.Authorization = token;
      if (getCookie('roleName') !== "ROLE_dept_country") {//获取最新消息
        this.getNews();
      }
      this.tourl()
    },
    getNews() {//获取最新消息
        this.Axios({
          url: Action.NOTICEMAGE_FINDRECEANNOUNCEMENTINFO,
          method: 'post',
          data: {
            noticeType:0,
          }
        }).then((res) => {
          var res = res.data;
          if (res.code === '000') {
            let num = 0;
            let newList = [];
            for (let i = 0; i < res.result.list.length; i++) {
              if (res.result.list[i].readState == '0') {
                this.news = true;
                num++;
              }

              //需要重点提示保存提示数据
              if (res.result.list[i].keyTips == '0') {
                if (res.result.list[i].keyTipsType == '0' || (res.result.list[i].keyTipsType == '1' && res.result.list[i].readState == '0' ) ) {//keyTipsType 0每次登录都显示, 1只显示一次
                  var nowTimeDate = new Date(res.result.list[i].nowTime);
                  var nowTimeGetTime = nowTimeDate.getTime();
                  var eTime = res.result.list[i].endTime.split(' ')[0];
                  var endTimeDate = new Date( (eTime+' 23:59:59') );
                  var endTimeGetTime = endTimeDate.getTime();
                  var strTimeDate = new Date( res.result.list[i].startTime );
                  var strTimeGetTime = strTimeDate.getTime();
                  if( (endTimeGetTime-nowTimeGetTime) > 0 && (nowTimeGetTime-strTimeGetTime) > 0 ){//结束日期大于当前日期，并且当前时间大于开始时间，需要添加到弹框显示
                    res.result.list[i].alertVar = true;
                    newList.push(res.result.list[i]);
                  }
                }
              }
            }
            window.sessionStorage.num = num;
            

            if (window.sessionStorage.num != 0 && getCookie('newsFlag') != 'on'&& getCookie('roleName') !== "ROLE_dept_country" && getCookie('roleName') !== "ROLE_mainten") {
              if( newList.length != 0 ){
                //通知公告重点弹框标识   1表示本次登录没有弹出过 2表示本次登录已弹出过
                sessionStorage.setItem("tipFlag", "1");
                sessionStorage.setItem("tipList", JSON.stringify(newList));
              }
              setCookie('newsFlag', 'on');
              this.$router.push("/collectNewsList");
            } else if (num == 0 && newList.length != 0 && getCookie('newsFlag') != 'on'&& getCookie('roleName') !== "ROLE_dept_country" && getCookie('roleName') !== "ROLE_mainten") {
              //通知公告重点弹框标识   1表示本次登录没有弹出过 2表示本次登录已弹出过
              sessionStorage.setItem("tipFlag", "1");
              sessionStorage.setItem("tipList", JSON.stringify(newList));
              setCookie('newsFlag', 'on');
            } else {
              this.tourl();
            }
          } else {
            this.openLoading().close();
            this.$alert(res.msg || '系统错误...', '错误提示', {
              cofirmButtonText: '确定',
              type: 'error'
            })
          }
        }).catch((err) => {
          console.log(err);
          this.openLoading().close();
          this.$alert(err.data.msg || '系统错误...', '错误提示', {
            cofirmButtonText: '确定',
            type: 'error'
          })
        })
    },
    tourl() {
      var locationUrl = window.location.pathname;
      let user = JSON.parse(getCookie("user"));
      if (getCookie('roleName') == "ROLE_med_inst") {
        if(user.activeFlag != '1'){
          console.log(user)
          this.$router.push("/orgmsgAffirm");
        }
      } else {
        if (getCookie('userInfo')) {
          if (getCookie('roleName') == "ROLE_dept_country") {
            // this.errUrl = "/mapPandect"
          }else if (getCookie('roleName') == "ROLE_mainten") {
            // this.errUrl = "/maBaInMa"
          } else {
            // this.errUrl = "/allorgmsg"
          }
        }
        if (locationUrl == "/login" || locationUrl == "/") {
          this.$router.push(this.errUrl)
        }
      }
    },
  },
  watch: {
    '$route': function () {
      this.urljudge();
      this.errUrl = '';
      Axios.interceptors.response.use(function (res) {//在这里对返回的数据进行处理
        var data = res.data;
        return res;
      }, (err)=> {
        if (err.response.status == '901' && !this.is901) {
          this.is901 = true;
          this.$confirm('登录状态已失效，请重新登录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.Axios({
              url: Action.SECURITY_LOGOUT,
              method: "post",
              data: {}
            }).then(res => {
              if (res.data.code == "000") {
                delCookie("newsFlag");
                delCookie("userInfo");
                delCookie("orgFlag");
                sessionStorage.setItem("tipFlag", '2');
                sessionStorage.setItem("tipList", '');
                this.is901 = false;
                this.$router.push("/loginList");
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          })
        }
        var isErrInfo = arguments[0].response.data.error_description.indexOf('Access token expired'); //权限是否过期
        if (isErrInfo >= 0) {
          setCookie('orgFlag', '');
          setCookie('userInfo', '');
          this.$router.push('/loginlist');
        }
        return Promise.reject(err);
      });
      return false;
    }
  },
  mounted() {
    this.urljudge();
    this.errUrl = '';
    let locationUrl = window.location;
    if(getCookie('isTest')==='test'){
      if(!getCookie('testPageState')){
           this.$router.push({path:'/testPage'})
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js